// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DigitalpaymentWebhook {
    static getAttributeTypeMap() {
        return DigitalpaymentWebhook.attributeTypeMap;
    }
}
DigitalpaymentWebhook.discriminator = undefined;
DigitalpaymentWebhook.additionalProperties = false;
DigitalpaymentWebhook.attributeTypeMap = [
    {
        "name": "eventId",
        "baseName": "eventId",
        "type": "string"
    },
    {
        "name": "createdTime",
        "baseName": "createdTime",
        "type": "Date"
    },
    {
        "name": "type",
        "baseName": "type",
        "type": "string"
    },
    {
        "name": "programId",
        "baseName": "programId",
        "type": "string"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "DigitalpaymentTransactionWebhookPayload"
    },
];
//# sourceMappingURL=digitalpaymentWebhook.js.map